import React from 'react';
import { ExpandChevronCell } from '../../../../../../../Components/BombiixAGGrid';
import type { BombiixCellRendererParams } from '../../../../../../../Components/BombiixAGGrid/types';
import type { MeasurementGridRow } from '../grid-types';

/**
 * Chevron on a product's first row that collapses/expands that product's rows, using the shared
 * BombiixAGGrid `ExpandChevronCell` so every expand affordance in the table looks identical.
 * Controlled mode: these rows collapse by being filtered out of the row data, not by AG Grid
 * node expansion, so the reducer owns the state.
 */
const ProductExpandCell: React.FC<BombiixCellRendererParams<MeasurementGridRow>> = ({ data, onRowChange }) => {
  if (!data?.isFirstOfProduct) return null;
  return (
    <ExpandChevronCell
      expanded={!data.collapsed}
      onToggle={() => onRowChange?.(data.id, '__collapse', '')}
      expandLabel="Expand product rows"
      collapseLabel="Collapse product rows"
      className="cag-chevron-toggle"
    />
  );
};

export default ProductExpandCell;
